module.exports = __webpack_public_path__ + "img/calculation.2bb15e4d.svg";